export default __webpack_public_path__ + "static/banner_img-7633c283bb7db18ccad79b2271c89cb5.webp";